module.exports = __webpack_public_path__ + "img/more.12d04b91.svg";